/* eslint-disable react/jsx-no-constructed-context-values */
import React from 'react';
import { Grid } from '@perxis-auto/ui-kit/lib/components/Grid';

import { ConstructorContext } from '@/context/constructor';

import { CatalogGridProps } from './ConstructorGrid.types';

function ConstructorGrid({
  grid,
  renderItem,
  skipFirstSubGrid = false,
}: CatalogGridProps) {
  const { type } = grid;

  if (type && !skipFirstSubGrid) {
    const { Container = React.Fragment, containerProps, ...gridWithoutContainer } = grid;

    return (
      <Container {...containerProps}>
        <ConstructorContext.Provider value={{ grid: gridWithoutContainer }}>
          {renderItem(grid)}
        </ConstructorContext.Provider>
      </Container>
    );
  }

  return (
    <Grid
      grid={grid}
      renderItem={renderItem}
      renderGrid={grid => <ConstructorGrid grid={grid} renderItem={renderItem} />}
    />
  );
}

export default ConstructorGrid;
